import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import {toast} from'react-toastify'
import Centre from '../Dropdowns/Centre'
import axios from '../../axios'
export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const authContext = useContext(AuthContext);
 const[centre,setCentre]=useState('')
 const centreId=authContext.userType==='Admin'?authContext.centre:centre
  const [employee, setEmployee] = useState({
 full_name:'',
 date:'',
 added_leaves:0,
 taken_leaves:0,
 remark:"",
});
const balance_leaves=employee.added_leaves-employee.taken_leaves

  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployee(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const addTrainer= () => {
    const requiredFields=[
      employee.full_name,
      employee.date,
      employee.added_leaves,
      employee.taken_leaves,
      balance_leaves,
    ]
    const isValid = requiredFields.every(field => field && (Array.isArray(field) ? field.length > 0 : true));
    
    if (!isValid) {
        toast.error('Please fill in all required fields');
        return;
    }

    axios.post('/employee/insert',{
      full_name:employee.full_name,
      date:employee.date,
      added_leaves:employee.added_leaves,
      taken_leaves:employee.taken_leaves,
      balance_leaves:balance_leaves,
      remark:employee.remark,
    })
      .then((result) => {
       toast.success("Employee Added")
        handlePageUpdate();
        addProductModalSetting();
      })
      .catch((err) =>
        { toast.error('Something went wrong')
          console.log(err)});
  };

  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Employee
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-3">
                       
                          <div>
                            <label
                                htmlFor="date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date <span className='text-red-600'>*</span>
                              </label>
                              <input
                               type="date"
                               id="date"
                               name="date"
                               value={employee.date}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                               
                               />
                            </div>
                           <div>
                            <label htmlFor="full_name"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Full Name <span className='text-red-600'>*</span>

                            </label>
                            <input type='text' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="full_name"
                            name="full_name"
                            value={employee.full_name}
                            onChange={handleInputChange}
                            />
                           
                           </div>

                           <div>
                            <label htmlFor="added_leaves"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Total Leaves <span className='text-red-600'>*</span></label>
                            <input type='number'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="added_leaves"
                            name="added_leaves"
                            value={employee.added_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                          
                          
                           <div>
                            <label htmlFor="taken_leaves"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Leaves Taken <span className='text-red-600'>*</span></label>
                            <input type='number'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="taken_leaves"
                            name="taken_leaves"
                            value={employee.taken_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           <div>
                            <label htmlFor="balance_leaves"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Balance Leaves <span className='text-red-600'>*</span></label>
                            <input type='text'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="balance_leaves"
                            name="balance_leaves"
                            value={balance_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           <div>
                            <label htmlFor="remark"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Remark</label>
                            <input type='text'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="remark"
                            name="remark"
                            value={employee.remark}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           
                          
                          
                                </div>
                                <div className="flex items-center space-x-4">
                               
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button
                            type="button"
                            className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                            onClick={addTrainer}
                          >
                            Add Employee
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            onClick={() => addProductModalSetting()}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          );
        }
